import { mapParamsBySchema, mapRowsBySchema } from '../../../util';
import Global from '../../../Services/Common/Global';
import { apiRequest } from '../../../Services/Common/ApiRequest';
import useSearchMutaion from '../../../Hooks/apis/useSearchMutaion';
import { M_NOT_BASIC_02_Schema } from './M_NOT_BASIC_02_Schema';
import useDeleteMutation from './../../../Hooks/apis/useDeleteMutaion';
import useSaveMutation from '../../../Hooks/apis/useSaveMutaion';
import Store from '../../../Store/Store';

const extractRows = (res) => {
  if (res == null) return [];
  if (Array.isArray(res)) return res;
  if (Array.isArray(res.data)) return res.data;
  if (Array.isArray(res.Data)) return res.Data;
  return [];
};

/** GetCompanyInfo — 회사(선택) 기준 사업장 목록 */
export const fetchCompanySites = async (coCd) => {
  const userInfo = Store.getState().BaseInfo.userInfo;
  const params = mapParamsBySchema(M_NOT_BASIC_02_Schema.mapper.companyInfo, {
    userInfo,
    search: { coCd: coCd || userInfo?.coCd },
  });
  const res = await apiRequest('post', Global.urls.Utility.getCompanyInfo, params);
  return extractRows(res);
};

/** GetDepBasicR1 — 사업장 기준 부서 목록 */
export const fetchDepartments = async (custCd, coCd) => {
  const userInfo = Store.getState().BaseInfo.userInfo;
  const params = mapParamsBySchema(M_NOT_BASIC_02_Schema.mapper.depBasic, {
    userInfo,
    search: { custCd, coCd: coCd || userInfo?.coCd },
  });
  const res = await apiRequest('post', Global.urls.Depart.getDepBasicR1, params);
  return extractRows(res);
};

export const useSearch1 = (successOptions) => {
  return useSearchMutaion((context) => {
    const params = mapParamsBySchema(
      M_NOT_BASIC_02_Schema.mapper.search1,
      context
    );
    return apiRequest('post', Global.urls.Notice.getNotBasic01R1, params);
  }, successOptions);
};
export const useSearch2 = (successOptions) => {
  return useSearchMutaion((context) => {
    const params = mapParamsBySchema(
      M_NOT_BASIC_02_Schema.mapper.search2,
      context
    );
    return apiRequest('post', Global.urls.Notice.getNotBasicR2, params);
  }, successOptions);
};
export const useSave1 = () =>
  useSaveMutation(async (rows) => {
    const userInfo = Store.getState().BaseInfo.userInfo;
    const payload = mapRowsBySchema(rows, M_NOT_BASIC_02_Schema.mapper.save1, {
      userInfo,
    });
    return apiRequest('post1', Global.urls.Notice.saveNotBasicU1, payload);
  });
export const useSave2 = () =>
  useSaveMutation(async (rows) => {
    const payload = mapRowsBySchema(rows, M_NOT_BASIC_02_Schema.mapper.save2);
    return apiRequest('post1', Global.urls.Notice.saveNotBasicU2, payload);
  });
export const useDelete1 = (options = {}) => {
  return useDeleteMutation(async (rows) => {
    const payload = mapRowsBySchema(rows, M_NOT_BASIC_02_Schema.mapper.delete1);
    return apiRequest('post1', Global.urls.Notice.deleteNotBasicD1, payload);
  }, options);
};

/** GetMemberListR1 — 회원 목록 (FCM 대상 조회) */
export const fetchMemberListR1 = async ({
  searchScope,
  coCd = '',
  custCd = '',
  depCd = '',
  searchText = '',
}) => {
  const params = mapParamsBySchema(M_NOT_BASIC_02_Schema.mapper.memberListR1, {
    searchScope,
    coCd,
    custCd,
    depCd,
    searchText,
  });
  const res = await apiRequest(
    'post',
    Global.urls.Utility.getMemberListR1,
    params
  );
  return extractRows(res);
};

const splitGubunDtlForFcm = (gubunDtl) => {
  if (Array.isArray(gubunDtl)) return gubunDtl.filter(Boolean);
  if (gubunDtl == null || gubunDtl === '') return [];
  return String(gubunDtl)
    .split(',')
    .map((s) => s.trim())
    .filter(Boolean);
};

const memberIdFromRow = (row) =>
  row?.id ?? row?.Id ?? row?.userId ?? row?.UserId ?? '';

/** 공지 저장 범위 → FCM 수신 userId 목록 (작성자 제외) */
export const resolveNoticeFcmTargetIds = async (savedRow, authorId) => {
  if (!savedRow) return [];

  const gubun = String(savedRow.gubun ?? '0');
  const coCd = (savedRow.coCd || '').trim();
  const custCd = (savedRow.custCd || '').trim();
  const dtl = splitGubunDtlForFcm(savedRow.gubunDtl);
  const ids = new Set();

  const mergeRows = (rows) => {
    (rows || []).forEach((row) => {
      const memberId = memberIdFromRow(row);
      if (memberId && memberId !== authorId) ids.add(memberId);
    });
  };

  if (gubun === '0') {
    mergeRows(await fetchMemberListR1({ searchScope: 'ALL' }));
    return [...ids];
  }

  if (gubun === '3') {
    if (coCd) mergeRows(await fetchMemberListR1({ searchScope: 'CO', coCd }));
    return [...ids];
  }

  if (gubun === '1') {
    const custList = dtl.length > 0 ? dtl : custCd ? [custCd] : [];
    await Promise.all(
      custList.map(async (c) => {
        mergeRows(await fetchMemberListR1({ searchScope: 'CUST', custCd: c }));
      })
    );
    return [...ids];
  }

  if (gubun === '2') {
    await Promise.all(
      dtl.map(async (dep) => {
        mergeRows(
          await fetchMemberListR1({ searchScope: 'DEP', depCd: dep })
        );
      })
    );
    return [...ids];
  }

  return [...ids];
};

